/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoModel } from '../../models/organization-logo-model';

export interface AdminFhirIdLogoIdGet$Params {
  fhirId: string;
  id: string;
}

export function adminFhirIdLogoIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdLogoIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationLogoModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdLogoIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationLogoModel>;
    })
  );
}

adminFhirIdLogoIdGet.PATH = '/Admin/{fhirId}/Logo/{id}';
